import { CSS_COLOR_REGEXP } from "config/constants";
import InputError from "editor/utils/InputError";

export default form => {
  let errors = {};

  if (form.bg_color && !CSS_COLOR_REGEXP.test(form.bg_color)) {
    errors.bg_color = new InputError("A valid background color is required");
    errors.metadata = true;
  }

  if (form.outline_color && !CSS_COLOR_REGEXP.test(form.outline_color)) {
    errors.outline_color = new InputError("A valid outline color is required");
    errors.metadata = true;
  }

  if (form.text_color && !CSS_COLOR_REGEXP.test(form.text_color)) {
    errors.text_color = new InputError("A valid text color is required");
    errors.metadata = true;
  }

  if (!form.slug) {
    errors.slug = new InputError("A slug is required");
    errors.metadata = true;
  }

  if (!form.stories || form.stories.length < 1) {
    errors.stories = new InputError("At least one story is required");
    errors.content = true;
  }
  if (!form.front_cover) {
    errors.front_cover = new InputError("A cover story is required");
    errors.content = true;
  }

  return Object.keys(errors).length > 0 ? errors : undefined;
};
